// extracted by mini-css-extract-plugin
module.exports = {"bodyWrapper":"page-content_bodyWrapper___UXLy"};